import role from '@/router/service-with-clients/admin-contractor/role'
import person from '@/router/service-with-clients/admin-contractor/person'
import online from '@/router/service-with-clients/admin-contractor/calendar/online'
import visibility from '@/router/service-with-clients/admin-contractor/calendar/visibility'
import mainPerson from '@/router/service-with-clients/admin-contractor/main-person'
import mainProperty from '@/router/service-with-clients/admin-contractor/main-property'
import mainVehicle from '@/router/service-with-clients/admin-contractor/main-vehicle'
import appraisal from '@/router/service-with-clients-intbls/admin-contractor/appraisal/index'
import clients from '@/router/service-with-clients/admin-contractor/clients'
import headers from '@/router/share/task-headers'

export default function (service, name) {
  return [
    ...role(service, name),
    ...person(service, name),
    ...online(service, name),
    ...visibility(service, name),
    ...mainPerson(service, name),
    ...mainProperty(service, name),
    ...mainVehicle(service, name),
    ...appraisal(service, name),
    ...clients(service, name),
    ...headers(service, name)
  ]
}
